export enum LiveRenderingEvent {
  CHANGE_PAGE = 'changePage',
  CHANGE_BRANCH = 'changeBranch',
}

export type LiveRenderingReceiveMessage = {
  event: LiveRenderingEvent;
  source: string;
  payload: string;
};

export type LiveRenderingSendMessage = {
  event: LiveRenderingEvent;
  payload?: string;
};

export type StylingConfigurationUrls = {
  themeUrl?: string;
  customCssUrl?: string;
  fontsUrl?: string;
};

export type ContentConfigurationUrls = {
  contentUrl?: string;
  globalUrl?: string;
  storesUrl?: string;
};

export type ConfigurationPaths = {
  version?: string;
  contentPath?: string;
  globalPath?: string;
  themePath?: string;
  customCssPath?: string;
  fontsPath?: string;
  fontFiles?: [];
  storesPath?: string;
};
